
// Navigation Bar

export const NBQH = "NBQH";
export const NBDTH = "NBDTH";
export const NBRMH = "NBRMH";
export const NBRH = "NBRH";
export const NBAH = "NBAH";
export const NBSH = "NBSH";

// Dashboard

export const DSCards = "DSCards";
export const DMStats = "DMStats";
export const DEStats = "DEStats";

// Message Queues

export const MMQTVM = "MMQTVM";
export const MMQTSI = "MMQTSI";

export const MMQDQAAB = "MMQDQAAB";

export const EMTVM = "EMTVM";
export const EMTRB = "EMTRB";
export const EMTARB = "EMTARB";
export const EMTSI = "EMTSI";

export const EMDUB = "EMDUB";
export const EMDRB = "EMDRB";
export const EMDDB = "EMDDB";
export const EMDARB = "EMDARB";
export const EMDQAAB = "EMDQAAB";

export const UFTVM = "UFTVM";
export const UFTRB = "UFTRB";
export const UFTDB = "UFTDB";
export const UFTAFB = "UFTAFB";

export const UFDUB = "UFDUB";
export const UFDRB = "UFDRB";
export const UFDDB = "UFDDB";
export const UFDARB = "UFDARB";
export const UFDQAAB = "UFDQAAB";

export const DQTVM = "DQTVM";
export const DQTRB = "DQTRB";

// Data Tables

export const LTVL = "LTVL";
export const LTUB = "LTUB";
export const LTRB = "LTRB";
export const LTALB = "LTALB";

export const LAFSB = "LAFSB";
export const LUFSB = "LUFSB";

export const AOELTVL = "AOELTVL";
export const AOELTUB = "AOELTUB";
export const AOELTRB = "AOELTRB";
export const AOELALB = "AOELALB";

export const AOELAMAB = "AOELAMAB";
export const AOELUMUB = "AOELUMUB";

export const RLTVL = "RLTVL";
export const RLUB = "RLUB";
export const RLRM = "RLRM";
export const RLANLB = "RLANLB";

export const RLAMAB = "RLAMAB";
export const RLUMUB = "RLUMUB";

export const STVS = "STVS";
export const STUB = "STUB";
export const STRB = "STRB";
export const STANB = "STANB";

export const SAMAB = "SAMAB";
export const SUMUB = "SUMUB";

export const CTVC = "CTVC";
export const CTUB = "CTUB";
export const CTRB = "CTRB";
export const CTACB = "CTACB";

export const CAMAB = "CAMAB";
export const CUMUB = "CUMUB";

export const SFTVF = "SFTVF";
export const SFTUB = "SFTUB";
export const SFTRB = "SFTRB";
export const SFTAFB = "SFTAFB";

export const SFAFNPIF = "SFAFNPIF";
export const SFAFCLIAF = "SFAFCLIAF";
export const SFAFOIDF = "SFAFOIDF";
export const SFAFFIDF = "SFAFFIDF";
export const SFAFSF = "SFAFSF";
export const SFADSB = "SFADSB";

export const SFUFNPIF = "SFUFNPIF";
export const SFUFNPIFB = "SFUFNPIFB";
export const SFUFCLIAF = "SFUFCLIAF";
export const SFUFCLIAB = "SFUFCLIAB";
export const SFUFOIDF = "SFUFOIDF";
export const SFUFOIDFB = "SFUFOIDFB";
export const SFUFFIDF = "SFUFFIDF";
export const SFUFSB = "SFUFSB";

export const PFTVF = "PFTVF";
export const PFTUB = "PFTUB";
export const PFTRB = "PFTRB";
export const PFTAFB = "PFTAFB";

export const PFAMSF = "PFAMSF";
export const PFAMAB = "PFAMAB";

export const PFUMSF = "PFUMSF";
export const PFUMAB = "PFUMAB";

export const CSTAVSB = "CSTAVSB";
export const CSTUB = "CSTUB";
export const CSTRB = "CSTRB";

export const CSUMUB = "CSUMUB";
export const CSUMAVB = "CSUMAVB";
export const CSUMDB = "CSUMDB";

// Rules

export const RTUB = "RTUB";
export const RTRB = "RTRB";
export const RTARB = "RTARB";

export const RARFBT = "RARFBT";
export const RARFTT = "RARFTT";
export const RARFVT = "RARFVT";
export const RARFSB = "RARFSB";

// Reporting

export const RERB = "RERB";

//Settings

export const CSNANVB = "CSNANVB";
export const CSNDB = "CSNDB";












